<template>
  <theme-container>
    <view class="base-container" wx:style="{{ style }}">
      <slot></slot>
    </view>
  </theme-container>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { isIframe } from '../../common/consts'

createComponent({
  options: {
    addGlobalClass: true,
    styleIsolation: 'shared'
  },
  data: {
    style: !isIframe ? {
      height: 'auto',
      minHeight: '100%',
      overflow: 'unset'
    } : {}
  }
})
</script>

<style lang="stylus">
view.base-container,
div.base-container
  background-color #f7f8fa
.base-container
  width 100%
  height 100%
  padding 20px
  box-sizing border-box
  overflow auto
  -webkit-overflow-scrolling touch
  &::after
    display block
    content ' '
    width 100%
    height 1px
    background-color transparent
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "theme-container": "../theme-container/index.mpx"
    }
  }
</script>
